import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import {
    BoardPage,
    ConfirmModal,
    HomePage,
    ProtectedGameRoute,
    ResetPasswordPage,
    SignInPage,
    CreateAccountPage,
    UserMenu,
    ConfirmAccountPage,
    NavigationSideBar,
    NotFoundPage,
    ProfilePage,
    SearchPage,
    ResendVerificationEmailPage,
    GameViewPage,
    AdminPage,
} from "./components";
import ForgotPasswordPage from "./components/forgot-password-page";
import { SocketProvider } from "./socket";
import { useInitializeSocket, useAuthState } from "./hooks";

// Wrapper to access location inside Router
const AppContent = () => {
    const { rematchBanner, acceptGlobalRematch, declineGlobalRematch } = useInitializeSocket();
    useAuthState();                    // Allows for authentication on refresh

    const location = useLocation();

    // Regular expressions for valid paths
    const validPaths = [
        /^\/$/,                        // Home
        /^\/play-game$/,               // Game
        /^\/sign-in$/,                 // Sign in
        /^\/reset-password$/,          // Reset password
        /^\/forgot-password$/,         // Forgot password
        /^\/create-account$/,          // Create account
        /^\/verify-email$/,            // Email verification
        /^\/profile\/[^/]+$/,          // Profile pages like /profile/username
        /^\/search-user$/,             // Search for users
        /^\/resend-verification$/,      // Resend account verification email
        /^\/game\/[^/]+$/,             // View past game
        /^\/admin$/,                   // Admin panel
    ];

    const isNotFound = !validPaths.some((pattern) => pattern.test(location.pathname));

    return (
        <>
            {rematchBanner && (
                <ConfirmModal
                    message={`${rematchBanner.from} wants a rematch. Accept?`}
                    onConfirm={acceptGlobalRematch}
                    onCancel={declineGlobalRematch}
                />
            )}
            {!isNotFound && <UserMenu />}
            <NavigationSideBar />
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/play-game" element={
                    <ProtectedGameRoute>
                        <BoardPage />
                    </ProtectedGameRoute>
                } />
                <Route path="/sign-in" element={<SignInPage />} />
                <Route path="/reset-password" element={<ResetPasswordPage />} />
                <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                <Route path="/create-account" element={<CreateAccountPage />} />
                <Route path="/verify-email" element={<ConfirmAccountPage />} />
                <Route path="/profile/:username" element={<ProfilePage />} />
                <Route path="/search" element={<SearchPage />} />
                <Route path="/resend-verification" element={<ResendVerificationEmailPage />} />
                <Route path="/game/:id" element={<GameViewPage />} />
                <Route path="/admin" element={<AdminPage />} />
                <Route path="*" element={<NotFoundPage />} />
            </Routes>
        </>
    );
};

const App = () => {
    return (
        <Router>
            <SocketProvider>
                <AppContent />
            </SocketProvider>
        </Router>
    );
};

export default App;
